<template>
	<div class="page pageContainer">
		<div class="nav">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>基础数据</el-breadcrumb-item>
				<el-breadcrumb-item>微信用户管理</el-breadcrumb-item>

			</el-breadcrumb>
		</div>

		<div>
			<el-tabs v-model="activeName" @tab-click="changeForm" type="card" style="height: 100%;">
				<el-tab-pane label="教师" name="teacher">
				</el-tab-pane>
				<el-tab-pane label="学生" name="student">
				</el-tab-pane>
				<el-tab-pane label="自报名学生" name="student2">
				</el-tab-pane>


			</el-tabs>

			<div v-show="activeName=='teacher'">


				<el-table :data="DataList" style="width: 100%;margin-bottom: 20px;" border stripe>

					<el-table-column prop="index" width="55" label="序号">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="username" label="教师姓名" width="120px"></el-table-column>
					<el-table-column prop="ucode" width="100" label="头像">
						<template slot-scope="scope">
							<img v-if="scope.row.avatar" style="width: 30px; height: 30px; border-radius: 4px;"
								:src="scope.row.avatar" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" min-width="120"></el-table-column>
					<el-table-column prop="ucode" label="工号"></el-table-column>
					<el-table-column prop="phone" label="手机号" width="120"></el-table-column>
					<el-table-column prop="area" label="区域" width="120"></el-table-column>
					<el-table-column prop="sort" label="排序" width="80"></el-table-column>



					<el-table-column fixed="right" label="操作" width="80">
						<template slot-scope="scope">
							<el-popconfirm v-if="!scope.row.locked" width="250" confirmButtonText='确定'
								cancelButtonText='取消' icon="el-icon-info" iconColor="red"
								@confirm="handleDel('t',scope.row)" placement="left" title="是否确定解绑？">
								<a slot="reference" size="small"
									style="color: red;font-size: 12px;margin-right: 10px; cursor: pointer;">解绑</a>
							</el-popconfirm>

						</template>
					</el-table-column>
				</el-table>


			</div>

			<div v-show="activeName=='student'">
				<el-row class="flexStart" style="margin-bottom: 10px;">
					<div>学生姓名：</div>
					<div>
						<el-input type="text" size="small" v-model.trim="searchForm1.stu_name"
							style="width: 200px;margin: 0 10px;" placeholder="学生姓名" />
					</div>
					<el-button size="small" icon="el-icon-search" @click="getSList" plain type="primary">查询</el-button>
				</el-row>

				<el-table stripe :data="Students" style="width: 100%;margin-bottom: 20px; color: #000;" border
					size="mini">

					<el-table-column prop="stu_code" width="110" label="学生编号">
					</el-table-column>
					<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
					<el-table-column prop="ucode" width="100" label="头像">
						<template slot-scope="scope">
							<img v-if="scope.row.avatar" style="width: 30px; height: 30px; border-radius: 4px;"
								:src="scope.row.avatar" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" min-width="120"></el-table-column>

					<el-table-column prop="exam_score" label="总分" width="60"></el-table-column>
					<el-table-column prop="volunteer" label="志愿" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.volunteer==1">第一志愿</span>
							<span v-if="scope.row.volunteer==2">第二志愿</span>
							<span v-if="scope.row.volunteer==3">第三志愿</span>
							<span v-if="scope.row.volunteer==0">无志愿</span>
						</template>
					</el-table-column>
					<el-table-column prop="gender" label="性别" width="60">
						<template slot-scope="scope">

							<span v-if="scope.row.gender==1">男</span>
							<span v-if="scope.row.gender==2">女</span>

							<span v-if="scope.row.gender==0">未知</span>
						</template>
					</el-table-column>

					<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>
					<el-table-column prop="major_name" label="专业代号及名称" min-width="140"></el-table-column>


					<el-table-column prop="phone" label="联系方式" min-width="120"></el-table-column>
					<el-table-column prop="status" label="状态" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.status==1" style="color: green;">已审核</span>
							<span v-if="scope.row.status==2" style="color: blue;">已缴费</span>
							<span v-if="scope.row.status==3" style="color: deepskyblue;">已录取</span>
							<span v-if="scope.row.status==4" style="color: #096DD9;">已分班</span>
							<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
							<span v-if="scope.row.status==0" style="color: gray;">未审核</span>
						</template>
					</el-table-column>




					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-popconfirm v-if="!scope.row.locked" width="250" confirmButtonText='确定'
								cancelButtonText='取消' icon="el-icon-info" iconColor="red"
								@confirm="handleDel('s0',scope.row)" placement="left" title="是否确定解绑？">
								<a slot="reference" size="small"
									style="color: red;font-size: 12px;margin-right: 10px; cursor: pointer;">解绑</a>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @current-change="handlePageChange1" :current-page="page1.pageIndex"
					:page-size="page1.pageSize" :total="page1.total" @size-change="handleSizeChange1"
					:page-sizes="page1.pageSizes" layout="total, prev, pager, next, sizes, jumper">
				</el-pagination>
			</div>

			<div v-show="activeName=='student2'">
				<el-row class="flexStart" style="margin-bottom: 10px;">
					<div>学生姓名：</div>
					<div>
						<el-input type="text" size="small" v-model.trim="searchForm2.stu_name"
							style="width: 200px;margin: 0 10px;" placeholder="学生姓名" />
					</div>
					<el-button size="small" icon="el-icon-search" @click="getSList2" plain type="primary">查询</el-button>
				</el-row>

				<el-table stripe :data="Students2" style="width: 100%;margin-bottom: 20px; color: #000;" border
					size="mini">

					<el-table-column type="index" width="60" label="序号">
						<template slot-scope="scope">
							<span>{{ scope.$index + 1 + (page2.pageIndex - 1) * page2.pageSize }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="stu_code" width="110" label="学生编号">
					</el-table-column>
					<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
					<el-table-column prop="ucode" width="100" label="头像">
						<template slot-scope="scope">
							<img v-if="scope.row.avatar" style="width: 30px; height: 30px; border-radius: 4px;"
								:src="scope.row.avatar" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" min-width="120"></el-table-column>
					<el-table-column prop="exam_score" label="总分" width="60"></el-table-column>
					<el-table-column prop="volunteer" label="志愿" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.volunteer==1">第一志愿</span>
							<span v-if="scope.row.volunteer==2">第二志愿</span>
							<span v-if="scope.row.volunteer==3">第三志愿</span>
							<span v-if="scope.row.volunteer==0">无志愿</span>
						</template>
					</el-table-column>
					<el-table-column prop="gender" label="性别" width="60">
						<template slot-scope="scope">

							<span v-if="scope.row.gender==1">男</span>
							<span v-if="scope.row.gender==2">女</span>

							<span v-if="scope.row.gender==0">未知</span>
						</template>
					</el-table-column>

					<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>
					<el-table-column prop="major_name" label="专业代号及名称" min-width="140"></el-table-column>


					<el-table-column prop="phone" label="联系方式" min-width="120"></el-table-column>
					<el-table-column prop="status" label="状态" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.status==1" style="color: green;">已审核</span>
							<span v-if="scope.row.status==2" style="color: blue;">已缴费</span>
							<span v-if="scope.row.status==3" style="color: deepskyblue;">已录取</span>
							<span v-if="scope.row.status==4" style="color: #096DD9;">已分班</span>
							<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
							<span v-if="scope.row.status==0" style="color: gray;">未审核</span>
						</template>
					</el-table-column>




					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-popconfirm v-if="!scope.row.locked" width="250" confirmButtonText='确定'
								cancelButtonText='取消' icon="el-icon-info" iconColor="red"
								@confirm="handleDel('s1',scope.row)" placement="left" title="是否确定解绑？">
								<a slot="reference" size="small"
									style="color: red;font-size: 12px;margin-right: 10px; cursor: pointer;">解绑</a>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @current-change="handlePageChange2" :current-page="page2.pageIndex"
					:page-size="page2.pageSize" :total="page2.total" @size-change="handleSizeChange2"
					:page-sizes="page2.pageSizes" layout="total, prev, pager, next, sizes, jumper">
				</el-pagination>

			</div>


		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: "teacher",
				DataList: [],
				Students: [],
				Students2: [],
				page1: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50],
					total: 0
				},
				page2: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50],
					total: 0
				},
				searchForm1: {},
				searchForm2: {}
			}
		},
		mounted() {
			this.getList()

		},
		methods: {
			changeForm() {
				console.log(this.activeName)
				if (this.activeName == "teacher") {
					this.getList()
				} else if (this.activeName == "student") {
					this.getSList()
				} else if (this.activeName == "student2") {
					this.getSList2()
				}
			},
			getList() {
				this.$http.post("/api/t_sch_teachers_list_wx", {
					pagesize: 10000,

				}).then(res => {
					this.DataList = res.data.data
					this.$nextTick(() => {
						this.$forceUpdate()
					})
				})
			},
			getSList() {
				this.$http.post("/api/sch_students_list_wx", {
					page: 1,
					pagesize: this.page1.pageSize,
					ktype: 'stu_name',
					keyword: this.searchForm1.stu_name,
				}).then(res => {
					this.Students = res.data
					this.page1.total = 20
					this.$nextTick(() => {
						this.$forceUpdate()
					})

				})
			},
			getSList2() {
				this.$http.post("/api/sch_students_list_pre_wx", {
					page: this.page2.pageIndex,
					pagesize: this.page2.pageSize,
					status: "all",
					ktype: 'stu_name',
					keyword: this.searchForm2.stu_name,

				}).then(res => {
					this.Students2 = res.data.data
					this.page2.total = res.data.page.count
					this.$nextTick(() => {
						this.$forceUpdate()
					})


				})
			},

			handleDel(t, row) {
				if (t == "t") {
					this.$http.post("/api/unbind_teacher", {
						id: row.id
					}).then(res => {
						this.getList()
					})

				} else if (t == "s0") {
					this.$http.post("/api/unbind_student", {
						id: row.id
					}).then(res => {
						this.getSList()
					})

				} else if (t == "s1") {
					this.$http.post("/api/unbind_student_pre", {
						id: row.id
					}).then(res => {
						this.getSList2()
					})

				}
			},

			handlePageChange1(e) {
				this.page1.pageIndex = e
				this.getSList()
			},
			handleSizeChange1(e) {
				this.page1.pageSize = e
				this.getSList()
			},

			handlePageChange2(e) {
				this.page2.pageIndex = e
				this.getSList2()
			},
			handleSizeChange2(e) {
				this.page2.pageSize = e
				this.getSList2()
			},
		}
	}
</script>

<style>
</style>
